import {
  hideAddCommentModal,
  hideCollectionBreakdownModal,
  setCollectionBreakdownModal,
  showAddCommentModal,
  showBankingCommentsModal,
  showCountDetailsModal,
  showSiteVarianceHistoryModal,
  showSuccessAlert,
} from "@actions/modals";
import collections from "@api/collections";
import CommentsButton from "@buttons/CommentsButton";
import PrimaryTabs from "@components/CollectionBreakdown/PrimaryTabs";
import SecondaryTabs from "@components/CollectionBreakdown/SecondaryTabs";
import React from "react";
import { connect } from "react-redux";
import { Button, Dimmer, Grid, Header, Loader, Modal } from "semantic-ui-react";

class CollectionBreakdownModal extends React.Component {
  state = {
    loading: false,
    detailsRow: null,
  };



  componentDidUpdate(prevProps) {
    const isOpen = this.props.modal?.open;
    if (
      isOpen &&
      ((this.props.modal.open && !prevProps.modal.open) ||
        this.props.modal.detailRef !== prevProps.modal.detailRef)
    ) {
      this.loadData();
    }
  }

  loadData = () => {
    const { modal } = this.props;
    if (!modal?.open || typeof modal.fnLoad !== "function") {
      this.setState({ loading: false });
      return Promise.resolve();
    }

    this.setState({ loading: true }, () => {
      modal.fnLoad(modal.detailRef).then(
        (response) =>
          this.setState({ loading: false }, () => {
            this.props
              .setCollectionBreakdownModal(response)
              .then(() => this.getComments());
          }),
        () => this.setState({ loading: false }),
      );
    });
  };

  getComments = () => {
    const { collectionId } = this.props.modal;
    collections.getCommentsByCollection(collectionId).then(
      (response) =>
        this.props.setCollectionBreakdownModal({
          ...this.props.modal,
          comments: response.comments,
        }),
      () => this.setState({ loading: false }),
    );
  };

  handleVarianceHistory = () => this.props.showSiteVarianceHistoryModal(true);

  onRowClick = (row) => this.props.showMachineCollectionDetailsModal(true);

  handleClose = () => this.props.hideCollectionBreakdownModal();

  handleViewComments = () => this.props.showBankingCommentsModal(true);

  handleCommentSave = async (comment) => {
    const { collectionId } = this.props.modal;
    collections.addComment(collectionId, comment).then((result) =>
      this.props.showSuccessAlert(result, "Success", async () => {
        this.props.hideAddCommentModal();
        this.getComments();
        this.loadData();
      }),
    );
  };

  handleAddComment = () => {
    const { siteText, weekText, egmText } = this.props.modal;
    this.props.showAddCommentModal(
      `${siteText} - ${weekText}`,
      egmText,
      this.handleCommentSave,
      this.getComments,
    );
  };

  onDetailsRowClick = (detailsRow) => this.setState({ detailsRow });

  onCountDetailsClick = async () => {
    const { batchId, collectionType } = this.state.detailsRow;
    this.props.showCountDetailsModal(
      { batchId, collectionType },
      this.loadData,
    );
  };

  onViewCommentsClick = () => {
    const { installationId } = this.props.modal;

    this.setState({ loading: true }, () => {
      collections.getCommentsByInstallation(installationId).then(
        (result) =>
          this.setState({ loading: false }, () =>
            this.props.showBankingCommentsModal(true, result),
          ),
        () => this.setState({ loading: false }),
      );
    });
  };

  render() {
    const { detailsRow, loading } = this.state;
    const { optionShowExport, optionShowVarianceHistory } = this.props.modal;

    const tablet = 11;
    const computer = 8;
    const largeScreen = 8;
    const wideScreen = 6;

    return (
      <Modal
        open={this.props.modal.open}
        onClose={this.handleClose}
        size="fullscreen"
        closeIcon
        className="h-80"
      >
        <Modal.Header>Collection Breakdown</Modal.Header>
        <Modal.Content className="h-100 flex-container">
          {loading ? (
            <Dimmer active inverted>
              <Loader inverted content="Loading" />
            </Dimmer>
          ) : (
            <Grid className="height-100 flex-container">
              <Grid.Row>
                <Grid.Column
                  tablet={16 - tablet}
                  computer={16 - computer}
                  largeScreen={16 - largeScreen}
                  widescreen={16 - wideScreen}
                >
                  <Header size="small" className="mb-1">
                    {this.props.modal.siteText} - {this.props.modal.weekText}
                    <Header.Subheader>
                      {this.props.modal.egmText}
                    </Header.Subheader>
                  </Header>
                </Grid.Column>
                <Grid.Column
                  tablet={tablet}
                  computer={computer}
                  largeScreen={largeScreen}
                  widescreen={wideScreen}
                  textAlign="right"
                >
                  <Button
                    color="blue"
                    content="Count Details"
                    disabled={!detailsRow}
                    onClick={this.onCountDetailsClick}
                  />
                  <Button color="teal" onClick={this.handleAddComment}>
                    Add Comment
                  </Button>
                  <CommentsButton
                    onClick={this.onViewCommentsClick}
                    content="Comment History"
                  />
                  {optionShowVarianceHistory && (
                    <Button positive>Site Variance History</Button>
                  )}
                  {optionShowExport && <Button color="blue">Export</Button>}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="flex-stretch">
                <Grid.Column
                  tablet={16 - tablet}
                  computer={16 - computer}
                  largeScreen={16 - largeScreen}
                  widescreen={16 - wideScreen}
                  className="height-100 gs-flex-container-vertical"
                >
                  <PrimaryTabs
                    loadData={this.loadData}
                    onDetailsRowClick={this.onDetailsRowClick}
                  />
                </Grid.Column>
                <Grid.Column
                  tablet={tablet}
                  computer={computer}
                  largeScreen={largeScreen}
                  widescreen={wideScreen}
                  className="height-100 gs-flex-container-vertical"
                >
                  <SecondaryTabs />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps, {
  showSuccessAlert,
  showBankingCommentsModal,
  showCountDetailsModal,
  showSiteVarianceHistoryModal,
  showAddCommentModal,
  setCollectionBreakdownModal,
  hideAddCommentModal,
  hideCollectionBreakdownModal,
})(CollectionBreakdownModal);
